import { render, staticRenderFns } from "./WebPushPopup.vue?vue&type=template&id=464f19b5&scoped=true"
import script from "./WebPushPopup.vue?vue&type=script&lang=ts"
export * from "./WebPushPopup.vue?vue&type=script&lang=ts"
import style0 from "./WebPushPopup.vue?vue&type=style&index=0&id=464f19b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464f19b5",
  null
  
)

export default component.exports